<div class="fc-option-input-group">
    <div>
        <input type="checkbox" [id]="elementOneId" [(ngModel)]="elementOneValue" (change)="onChange()" [disabled]="settings.disabled()"> 
        <label [for]="elementOneId">{{ settings.elementOne.label}}</label>
     </div>
    <div>
        <input type="checkbox"  [id]="elementTwoId" [(ngModel)]="elementTwoValue" (change)="onChange()" [disabled]="settings.disabled()">
        <label [for]="elementTwoId">{{ settings.elementTwo.label}}</label>
    </div>
</div>